export enum LeaderboardTypesEnum {
	Attendees = 0,
	Revenue = 1
}

export enum LeaderboardInterestsEnum {
	Running = 0,
	Other = 1,
}
